import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CapturumButtonModule } from '@capturum/ui/button';
import { FieldType, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';

interface AdditionalDefaultOptions {
  actionButtons: boolean;
  deletable: boolean;
}

@Component({
  selector: 'app-formly-button-type',
  imports: [CapturumButtonModule, TranslateModule],
  templateUrl: './formly-button-type.component.html',
  styleUrl: './formly-button-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyButtonTypeComponent extends FieldType implements OnInit {
  public override defaultOptions?: Partial<FormlyFieldConfig<FormlyFieldProps & AdditionalDefaultOptions>> = {
    props: {
      actionButtons: false,
      deletable: true,
    },
  };

  private confirmationService = inject(ConfirmationService);
  private translateService = inject(TranslateService);

  public ngOnInit(): void {
    if (this.props.actionButtons) {
      this.formControl.disable();
    }
  }

  public remove(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('confirm.title'),
      message: this.translateService.instant('confirm.entity.delete.confirmation', {}),
      accept: () => {
        if (this.props.onRemove) {
          this.props.onRemove(this.field, this.formControl);
        }
      },
    });
  }

  public edit(): void {
    if (this.props.onEdit) {
      this.props.onEdit(this.field, this.formControl, () => {
        this.formControl.patchValue({
          is_edit: true,
        });
      });

      return;
    }

    this.formControl.patchValue({
      is_edit: true,
    });
  }

  public save(): void {
    if (this.props.onSave) {
      this.props.onSave(this.field, this.formControl, () => {
        this.formControl.patchValue({
          is_edit: false,
        });
      });

      return;
    }

    this.formControl.patchValue({
      is_edit: false,
    });
  }

  public cancel(): void {
    if (this.props.onCancel) {
      this.props.onCancel(this.field, this.formControl, () => {
        this.formControl.patchValue({
          is_edit: false,
        });
      });

      return;
    }

    this.formControl.patchValue({
      is_edit: false,
    });
  }
}
